module.exports = __webpack_public_path__ + "img/find.d1f12986.svg";